import React from 'react'
import Form from 'antd/lib/form'
import InputField from '@UI/Form/Fields/input'
import PasswordField from '@UI/Form/Fields/password'
import TermsCheckbox from '@components/Auth/TermsCheckbox'
import FormError from '@components/Auth/FormError'
import Button from '@UI/antd/Button/Button'
import { history } from '@components/App'
import routes from '@utils/constants/routes'
import styles from './index.scss'

interface Props {
    i18n: any
    errors: any
    errorLink: string
    resendConfirmationCode: any
    loggingIn: boolean
    login: {
        errors: any
        status: string
    }
}
const LoginForm = ({ i18n, login, errors, errorLink, resendConfirmationCode, loggingIn }: Props) => {
    return (
        <div className={styles.container}>
            <InputField
                name="email"
                label="Email address"
                required
                rules={[
                    {
                        type: 'email',
                        message: 'Invalid Email'
                    }
                ]}
            />
            <PasswordField name="password" label="Create password" required />
            <TermsCheckbox i18n={i18n} />
            <Form.Item noStyle shouldUpdate={(prev, next) => prev.endpointType !== next.endpointType}>
                {({ getFieldValue }) => (
                    <FormError
                        errorMsg={login?.errors}
                        status={login.status}
                        errors={errors}
                        onClick={
                            errorLink === 'sign-up'
                                ? () => history.push(routes.subscription.signup._)
                                : () => resendConfirmationCode(getFieldValue('email'))
                        }
                    />
                )}
            </Form.Item>
            <Button typeButton="primary-solid" htmlType="submit" isRound loading={loggingIn}>
                Sign in
            </Button>
        </div>
    )
}

export default LoginForm
